import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=6a299e40&scoped=true"
import script from "./Bread.vue?vue&type=script&lang=js"
export * from "./Bread.vue?vue&type=script&lang=js"
import style0 from "./Bread.vue?vue&type=style&index=0&id=6a299e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_babel-core@6.26.3_css-loader@6.11.0_webpack@5.100_4xpmdqc3iaixeru4y6alscik5i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a299e40",
  null
  
)

export default component.exports